<template>
    <!-- Order Payment Status-->
    <span v-if="order.groupBooking"
          data-component="OrderGroupBookingLabel"
          class="label label-purple">{{ l('ORDERS.GROUP_BOOKING_LABEL') }}</span>
</template>

<script>

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
};
</script>
